import { render, staticRenderFns } from "./CollapseHorizontal.vue?vue&type=template&id=48f31adb&scoped=true"
import script from "./CollapseHorizontal.vue?vue&type=script&lang=ts"
export * from "./CollapseHorizontal.vue?vue&type=script&lang=ts"
import style0 from "./CollapseHorizontal.vue?vue&type=style&index=0&id=48f31adb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f31adb",
  null
  
)

export default component.exports